import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";

import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {ROUTES} from "../../../../../routes";
import PrivacyPolicyTerms from "../../../../popups/userPopup/privacyPolicyTerms";
import {changeUserInfo} from "../../../../../actions/actionFunctions";
import GroheCartHeaderCommon from "../groheCartHeaderCommon";
import GroheCartStickyFooter from "../groheCartStickyFooter";


const GroheCartTerms = (props) => {

  const {history, changeUserInfo, userIsLoggedIn, isMobile, fabricatorSettings} = props;

  const termsAcceptClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.cartTermsAccept);
    changeUserInfo({
      agreedToTerms: true
    });
    history.push(
      userIsLoggedIn
        ? fabricatorSettings.hasPaymentGateway
          ? ROUTES.cartBilling
          : ROUTES.cartConfirm
        : isMobile
          ? ROUTES.cartRegister
          : ROUTES.cartLogin
    );
  };

  const stickyFooterButtons = [
    {
      translate: "buttons.back",
      classes: "look-button--secondary",
      onClick: () => {
        history.push(ROUTES.cartRegister);
      }
    },
    {
      translate: "buttons.accept",
      classes: "look-button--blue",
      onClick: termsAcceptClick
    }
  ];

  return (
    <div className={"gc" + (isMobile ? "" : " gc--terms")}>
      <div className="gc-body">
        <GroheCartHeaderCommon title="grohe.cart.terms.title"/>
        <div className="gc-terms">
          <PrivacyPolicyTerms/>
        </div>
        {isMobile ? <div className="gc-spacer"/> : (
          <div className="gc-form__submit">
            <div className="gc-form__submit-left"/>
            <div className="gc-form__submit-right">
              <Button className="look-button look-button--blue look-button--big look-button--large nowrap"
                      onClick={termsAcceptClick}>
                <FormattedMessage id="buttons.accept"/>
              </Button>
            </div>
          </div>
        )}
      </div>
      {isMobile ? <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {userIsLoggedIn} = store.userState;
  const {isMobile} = store.serverState;
  const {settings} = store.fabricatorState;

  return {
    userIsLoggedIn,
    isMobile,
    fabricatorSettings: settings,
  };
};

const mapDispatchToProps = {
  changeUserInfo,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheCartTerms)
)
